// import { useState } from "react";
// import "../Styles/Blogs.css";

// const Blog = () => {
//     // Sample blog data
//     const blogPosts = [
//         {
//           id: 1,
//           title: "Essential Tips for Moong Crop Farming with GICS Crop Protection Solutions",
//           excerpt: `Moong, also known as green gram (Vigna radiata), is one of the most significant pulse crops in India. Farmers from all over the world grow moong crops for their economic and nutritional value. Moong's high nutritional content and soil-enriching qualities make it a popular crop in areas like Madhya Pradesh, Punjab, Rajasthan, Uttar Pradesh, and Maharashtra. It’s a short-duration crop with several advantages. Due to its high protein content and abundant vital minerals, moong is a staple in Indian meals. It also fixes atmospheric nitrogen to increase soil fertility and grows within 60–70 days, facilitating several crop cycles throughout the year. However, to ensure high yields and quality produce, farmers must follow the right agronomic practices and use effective crop protection solutions. This blog will discuss the challenges of moong farming and how Globe International Crop Science products can help overcome these obstacles.`,
//           content: [
//             {
//               head: "Pest and Insect Management:",
//               para: "Moong crops are at risk from pests that can harm plant health and lower yield, such as aphids, whiteflies, thrips, and pod borer. Globe International Crop Science provides the best range of insecticides such as Cor-Ex and Kito, which takes immediate action against sucking pests like aphids and whiteflies, affecting moong crops. Also, products like Clear can manage fungal diseases by spraying 250-300 gm per acre.",
//             },
//             {
//               head: "Fertilizer Management:",
//               para: "As a legume, moong fixes nitrogen on its own, but it additionally benefits from extra phosphorus and other minerals. It is possible to strengthen root development and pod formation by applying 100 kg of Single Super Phosphate (SSP) per acre. To promote healthier plant growth, Globe International Crop Science supplies micronutrients and bio-fertilizers to aid in nitrogen fixation and general nutrient balance.",
//             },
//             {
//               head: "Weed management:",
//               para: "Weeds lower agricultural productivity by competing with moong plants for water, light, and nutrients. Healthy crop growth requires early weed management. GICS has pre-emergent herbicide for moong fields in Madhya Pradesh and Punjab to prevent weed germination. Post-emergent herbicide for moong can control unwanted weed growth in standing crops.",
//             },
//             {
//               head: "Disease Control in Moong Fields:",
//               para: "Production from crops can be greatly impacted by common fungal diseases such as bacterial leaf spot, powdery mildew, and root rot. GICS fungicides can effectively prevent and control fungal infections by stopping early-stage attacks and further spread.",
//             },
//             {
//               head: "Improving Moong Yield with Plant Growth Promoters:",
//               para: "Farmers should focus on better nutrient absorption, stronger root development, and increased plant immunity to enhance yield. GICS Plant Growth Promoters (PGP) like More, Raftar Plus, and Top N Top effectively improve overall plant health.",
//             },
//             {
//               head: "Conclusion",
//               para: "Using efficient crop protection techniques and scientific growing methods makes moong farming a profitable business. Farmers may boost crop quality, ensure pest-free, healthy harvests, and enhance production by using products from Globe International Crop Science. Whether you need herbicides in Madhya Pradesh, pesticides in Punjab, or insecticides for moong farming, GICS products are made to assist farmers in overcoming the difficulties of moong farming and increasing their harvests.",
//             },
//           ],
//         },
//       ];
      

//     const [selectedPost, setSelectedPost] = useState(null);

//     const openFullBlog = (post) => {
//         setSelectedPost(post);
//         window.scrollTo(0, 0);
//     };

//     const closeFullBlog = () => {
//         setSelectedPost(null);
//     };

//     return (
//         <div className="blog-container">
//             <div className="blog-header">
//                 <h1>Our Blog</h1>
//                 <p>Latest news, tips, and insights for aggriculture product</p>
//             </div>
//             {selectedPost ? (
//                 <div className="full-blog">
//                     <button className="back-button" onClick={closeFullBlog}>
//                         ← Back to blogs
//                     </button>
//                     <div className="full-blog-content">
//                         <h2 className="full-blog-title">{selectedPost.title}</h2>
//                         <div className="full-blog-text">
//                             <h4>{selectedPost?.excerpt}</h4>
//                             {/* Conditionally render array content */}
//                             {Array.isArray(selectedPost.content) ? (
//                                 selectedPost.content.map((section, index) => (
//                                     <div key={index} className="blog-section">
//                                         <h3 className="blog-section-head">{section.head}</h3>
//                                         <p className="blog-section-para">{section.para}</p>
//                                     </div>
//                                 ))
//                             ) : (
//                                 <p>{selectedPost.content}</p>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             ) : (
//                 <div className="blog-grid">
//                     {blogPosts.map((post) => (
//                         <div className="blog-card" key={post.id}>

//                             <div className="blog-content">
//                                 <h2 className="blog-title" onClick={() => openFullBlog(post)}>
//                                     {post.title}
//                                 </h2>
//                                 <p className="blog-excerpt">{post.excerpt}</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Blog

import { useState } from "react";
import "../Styles/Blogs.css";

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title:
        "Essential Tips for Moong Crop Farming with GICS Crop Protection Solutions",
      excerpt: [
        "Moong, also known as green gram (Vigna radiata), is one of the most significant pulse crops in India.",
        "Farmers from all over the world grow moong crops for their economic and nutritional value.",
        "Moong's high nutritional content and soil-enriching qualities make it a popular crop in areas like Madhya Pradesh, Punjab, Rajasthan, Uttar Pradesh, and Maharashtra.",
        "It’s a short-duration crop with several advantages.",
        "Due to its high protein content and abundant vital minerals, moong is a staple in Indian meals.",
        "It also fixes atmospheric nitrogen to increase soil fertility and grows within 60–70 days, facilitating several crop cycles throughout the year.",
        <>
          However, to ensure <strong>high yields and quality produce,</strong> farmers must follow the right agronomic practices and use effective crop protection solutions.
        </>,
        "This blog will discuss the challenges of moong farming and how Globe International Crop Science products can help overcome these obstacles.",
      ],
      content: [
        {
          head: "Pest and Insect Management:",
          para: "Moong crops are at risk from pests that can harm plant health and lower yield, such as aphids, whiteflies, thrips, and pod borer. Globe International Crop Science provides the best range of insecticides such as Cor-Ex and Kito, which takes immediate action against sucking pests like aphids and whiteflies, affecting moong crops. Also, products like Clear can manage fungal diseases by spraying 250-300 gm per acre.",
        },
        // {
        //   head: "Fertilizer Management:",
        //   para: "As a legume, moong fixes nitrogen on its own, but it additionally benefits from extra phosphorus and other minerals. It is possible to strengthen root development and pod formation by applying 100 kg of Single Super Phosphate (SSP) per acre. To promote healthier plant growth, Globe International Crop Science supplies micronutrients and bio-fertilizers to aid in nitrogen fixation and general nutrient balance.",
        // },
        {
          head: "Weed management:",
          para: "Weeds lower agricultural productivity by competing with moong plants for water, light, and nutrients. Healthy crop growth requires early weed management. GICS has pre-emergent herbicide for moong fields in Madhya Pradesh and Punjab to prevent weed germination. Post-emergent herbicide for moong can control unwanted weed growth in standing crops.",
        },
        {
          head: "Disease Control in Moong Fields:",
          para: "Production from crops can be greatly impacted by common fungal diseases such as bacterial leaf spot, powdery mildew, and root rot. GICS fungicides can effectively prevent and control fungal infections by stopping early-stage attacks and further spread.",
        },
        {
          head: "Improving Moong Yield with Plant Growth Promoters:",
          para: "Farmers should focus on better nutrient absorption, stronger root development, and increased plant immunity to enhance yield. GICS Plant Growth Promoters (PGP) like More, Raftar Plus, and Top N Top effectively improve overall plant health.",
        },
        {
          head: "Conclusion",
          para: "Using efficient crop protection techniques and scientific growing methods makes moong farming a profitable business. Farmers may boost crop quality, ensure pest-free, healthy harvests, and enhance production by using products from Globe International Crop Science. Whether you need herbicides in Madhya Pradesh, pesticides in Punjab, or insecticides in chhattisgarh for moong farming, GICS products are made to assist farmers in overcoming the difficulties of moong farming and increasing their harvests.",
        },
      ],
    },
  ];

  const [selectedPost, setSelectedPost] = useState(null);

  const openFullBlog = (post) => {
    setSelectedPost(post);
    window.scrollTo(0, 0);
  };

  const closeFullBlog = () => {
    setSelectedPost(null);
  };

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h1>Our Blog</h1>
        <p>Latest news, tips, and insights for agriculture products</p>
      </div>

      {selectedPost ? (
        <div className="full-blog">
          <button className="back-button" onClick={closeFullBlog}>
            ← Back to blogs
          </button>
          <div className="full-blog-content">
            <h2 className="full-blog-title">{selectedPost.title}</h2>
            <div className="full-blog-text">
              {/* First two lines as separate paragraph */}
              <p className="excerpt-line">
                Moong, also known as green gram (Vigna radiata), is one of the most significant pulse crops in India. Farmers from all over the world grow moong crops for their economic and nutritional value.
              </p>

              {/* Join remaining string content into one paragraph */}
              <p className="excerpt-line">
                {selectedPost.excerpt
                  .slice(2)
                  .filter(line => typeof line === "string")
                  .join(" ")}
              </p>

              {/* Render JSX content separately */}
              {selectedPost.excerpt.map((line, idx) =>
                typeof line !== "string" ? (
                  <p key={idx} className="excerpt-line">{line}</p>
                ) : null
              )}

              {/* Full content with headings */}
              {selectedPost.content.map((section, index) => (
                <div key={index} className="blog-section">
                  <h3 className="blog-section-head">{section.head}</h3>
                  <p className="blog-section-para">{section.para}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <div className="blog-card" key={post.id}>
              <div className="blog-content">
                <h2 className="blog-title" onClick={() => openFullBlog(post)}>
                  {post.title}
                </h2>
                <p className="blog-excerpt">
                  {post.excerpt[0]}...
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Blog;
